import CallReminderModal from './call_reminder_modal';

export const displayCallReminderModal = (activityLog, projectResponseActionId) => {
    if (isCallReminderActive()) {
        const callReminderModal = CallReminderModal(activityLog);
        callReminderModal.show(projectResponseActionId);
    }
};

export const isCallReminderActive = () => {
    return $('#call-reminder-modal').length > 0;
};

